import dayjs from 'dayjs';
import mapboxgl from 'mapbox-gl';
import React, { FC } from 'react';
import ReactDOM from 'react-dom';
import { PopupEvent } from '../map/utils/renderPopup';

export function renderCourierPopup(
  event: PopupEvent,
  popup: mapboxgl.Popup,
  map: mapboxgl.Map
) {
  const coordinates = (event.features[0].geometry as any).coordinates.slice();
  const properties = event.features[0].properties as {
    courierName: string;
    locationUpdatedAt: string;
  };

  // Ensure that if the map is zoomed out such that
  // multiple copies of the feature are visible, the
  // popup appears over the copy being pointed to.
  while (Math.abs(event.lngLat.lng - coordinates[0]) > 180) {
    coordinates[0] += event.lngLat.lng > coordinates[0] ? 360 : -360;
  }

  const node = document.createElement('div');

  ReactDOM.render(<CourierPopup properties={properties} />, node);

  popup.setLngLat(coordinates).setDOMContent(node).addTo(map);
}
export function renderInstructionPopup(
  event: PopupEvent,
  popup: mapboxgl.Popup,
  map: mapboxgl.Map
) {
  const coordinates = (event.features[0].geometry as any).coordinates.slice();
  const properties = event.features[0].properties as {
    type: string;
    orderId: string;
    idWithListNumber?: string;
    label: string;
    address: string;
    name: string;
    phone: string;
  };

  // Ensure that if the map is zoomed out such that
  // multiple copies of the feature are visible, the
  // popup appears over the copy being pointed to.
  while (Math.abs(event.lngLat.lng - coordinates[0]) > 180) {
    coordinates[0] += event.lngLat.lng > coordinates[0] ? 360 : -360;
  }

  const node = document.createElement('div');

  ReactDOM.render(<BundlePopup properties={properties} />, node);

  popup.setLngLat(coordinates).setDOMContent(node).addTo(map);
}
const BundlePopup: FC<{
  properties: {
    type: string;
    orderId: string;
    idWithListNumber?: string;
    label: string;
    address: string;
    name: string;
    phone: string;
  };
}> = ({ properties }) => {
  const multiple = properties.label === 'M';
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '12ch auto' }}>
      <div>Type</div>
      <div>{properties.type}</div>
      <div>{multiple ? 'Order IDs' : 'Order ID'}</div>
      <div>{properties.idWithListNumber || properties.orderId}</div>
      <div>List number</div>
      <div>{multiple ? 'Multiple' : properties.label}</div>
      <div>Address</div>
      <div>{properties.address}</div>
      <div>Name</div>
      <div>{properties.name}</div>
      <div>Phone</div>
      <div>{properties.phone}</div>
    </div>
  );
};
const CourierPopup: FC<{
  properties: {
    courierName: string;
    locationUpdatedAt: string;
  };
}> = ({ properties }) => {
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '17ch auto' }}>
      <div>Name</div>
      <div>{properties.courierName}</div>
      <div>Location updated</div>
      <div>{dayjs(properties.locationUpdatedAt).format('DD.MM HH:mm:ss')}</div>
    </div>
  );
};
